import api from '../../api/index.api'
import FeedbackTypes from './feedback.types'
import { createPagedFetchThunk } from '../utils/createPagedFetchThunk'

export const onGetFeedbacks = createPagedFetchThunk({
	type: FeedbackTypes.GET_FEEDBACKS,
	fetchApi: page => api.feedbackApi.getAllFeedback(page),
})

export const onUpdateFeedbacks = (data, cb) => {
	return async dispatch => {
		try {
			const result = await api.feedbackApi.updateFeedback({
				...data,
				feedbackID: data.id,
			})
			dispatch({
				type: FeedbackTypes.UPDATE_FEEDBACKS,
				payload: result,
			})
			cb && cb(true, result)
		} catch (err) {
			cb && cb(false, err.message)
		}
	}
}

export const onSelectFeedbacks = (data, cb) => {
	return async dispatch => {
		try {
			dispatch({
				type: FeedbackTypes.SELECT_FEEDBACKS,
				payload: data,
			})
			cb && cb(true, data)
		} catch (err) {
			cb && cb(false, err.message)
		}
	}
}

export const onAddReply = (data, cb) => {
	return async dispatch => {
		try {
			const result = await api.feedbackApi.addReply(data)
			dispatch({
				type: FeedbackTypes.ADD_REPLY,
				payload: result,
			})
			cb && cb(true, result)
		} catch (err) {
			cb && cb(false, err.message)
		}
	}
}
